var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMyList = function SvgMyList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 3.526a4.85 4.85 0 0 0-4.85 4.85v16a4.85 4.85 0 0 0 4.85 4.85h16a4.85 4.85 0 0 0 4.85-4.85v-16a4.85 4.85 0 0 0-4.85-4.85h-16Zm-3.15 4.85a3.15 3.15 0 0 1 3.15-3.15h16a3.15 3.15 0 0 1 3.15 3.15v16a3.15 3.15 0 0 1-3.15 3.15h-16a3.15 3.15 0 0 1-3.15-3.15v-16Zm5.65 1a1.5 1.5 0 0 0 0 3h11a1.5 1.5 0 1 0 0-3H11Zm-1.5 7a1.5 1.5 0 0 1 1.5-1.5h8a1.5 1.5 0 0 1 0 3h-8a1.5 1.5 0 0 1-1.5-1.5Zm1.5 4a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 1 0 0-3h-3Z"
  })));
};
export default SvgMyList;